import type { Citation } from "@/lib/citations";

/**
 * The primary sources behind the free scaffold inspection due-date tool
 * (/free/scaffold-inspection-due-date), read on the accessed date: regulation
 * 12 and Schedule 7 of the Work at Height Regulations 2005 on
 * legislation.gov.uk (every regulation quotation in
 * lib/marketing/scaffold-inspection/due-date.ts is checked against the
 * regulation's text there) and HSE's scaffolding pages.
 */
const ACCESSED = "2026-10-31";

export const WAHR_REG_12_URL = "https://www.legislation.gov.uk/uksi/2005/735/regulation/12";
export const WAHR_SCHEDULE_7_URL = "https://www.legislation.gov.uk/uksi/2005/735/schedule/7";
export const WAHR_NI_URL = "https://www.legislation.gov.uk/nisr/2005/279/contents";
export const HSE_SCAFFOLD_FAQ_URL = "https://www.hse.gov.uk/construction/faq-scaffold.htm";
export const HSE_SCAFFOLDING_URL = "https://www.hse.gov.uk/construction/safetytopics/scaffoldinginfo.htm";

export const SCAFFOLD_INSPECTION_SOURCES: readonly Citation[] = [
  {
    title: "The Work at Height Regulations 2005, regulation 12 (Inspection of work equipment)",
    url: WAHR_REG_12_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
  {
    title: "The Work at Height Regulations 2005, Schedule 7 (Particulars to be included in a report of inspection)",
    url: WAHR_SCHEDULE_7_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
  {
    title: "Scaffolding: frequently asked questions",
    url: HSE_SCAFFOLD_FAQ_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "Scaffolding",
    url: HSE_SCAFFOLDING_URL,
    publisher: "Health and Safety Executive",
    accessedAt: ACCESSED,
  },
  {
    title: "The Work at Height Regulations (Northern Ireland) 2005",
    url: WAHR_NI_URL,
    publisher: "legislation.gov.uk",
    accessedAt: ACCESSED,
  },
];
